import React from 'react'
import Kpiresponseviewfile from '../../components/kpiresponsereportcomponent/Kpiresponseviewfile'

function  Kpiresponseview({renderPageContent}) {
    return (
        <>
                        <Kpiresponseviewfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpiresponseview